import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createGroupMembersEventRequest = { event: '_groupMembersEvent' };
var _createGroupMembersEventResponse = { event: '_groupMembersEvent' };
var _dateAndTimeSettings = {
    startDate: 'google.protobuf.Timestamp',
    endDate: 'google.protobuf.Timestamp',
};
var _deleteGroupMembersEventRequest = {};
var _deleteGroupMembersEventResponse = { event: '_groupMembersEvent' };
var _groupMembersEvent = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    dateAndTimeSettings: '_dateAndTimeSettings',
};
var _updateGroupMembersEventRequest = {
    mask: 'google.protobuf.FieldMask',
    event: '_groupMembersEvent',
};
var _updateGroupMembersEventResponse = { event: '_groupMembersEvent' };
function resolveWixSocialgroupsV1GroupMemberEventsServiceUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/groupmembers-events',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Create group member event and Wix Events' event */
export function createGroupMembersEvent(payload) {
    var _a = serializer(_createGroupMembersEventRequest, { _dateAndTimeSettings: _dateAndTimeSettings, _groupMembersEvent: _groupMembersEvent }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createGroupMembersEventResponse, {
        _dateAndTimeSettings: _dateAndTimeSettings,
        _groupMembersEvent: _groupMembersEvent,
    }).fromJSON;
    function __createGroupMembersEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.socialgroups.v1.group_members_event',
            method: 'POST',
            methodFqn: 'wix.socialgroups.v1.GroupMemberEventsService.CreateGroupMembersEvent',
            url: resolveWixSocialgroupsV1GroupMemberEventsServiceUrl({
                protoPath: '/v1/group-members-events',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createGroupMembersEvent.fromReq = fromReq;
    __createGroupMembersEvent.__isAmbassador = true;
    return __createGroupMembersEvent;
}
/** Update group member event(if exists) and Wix Events' event, supports partial update */
export function updateGroupMembersEvent(payload) {
    var _a = serializer(_updateGroupMembersEventRequest, { _dateAndTimeSettings: _dateAndTimeSettings, _groupMembersEvent: _groupMembersEvent }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateGroupMembersEventResponse, {
        _dateAndTimeSettings: _dateAndTimeSettings,
        _groupMembersEvent: _groupMembersEvent,
    }).fromJSON;
    function __updateGroupMembersEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.socialgroups.v1.group_members_event',
            method: 'PATCH',
            methodFqn: 'wix.socialgroups.v1.GroupMemberEventsService.UpdateGroupMembersEvent',
            url: resolveWixSocialgroupsV1GroupMemberEventsServiceUrl({
                protoPath: '/v1/group-members-events/{event.eventId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateGroupMembersEvent.fromReq = fromReq;
    __updateGroupMembersEvent.__isAmbassador = true;
    return __updateGroupMembersEvent;
}
/** Delete group member event(if exists) and cancel corresponding Wix Events' event */
export function deleteGroupMembersEvent(payload) {
    var _a = serializer(_deleteGroupMembersEventRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteGroupMembersEventResponse, {
        _dateAndTimeSettings: _dateAndTimeSettings,
        _groupMembersEvent: _groupMembersEvent,
    }).fromJSON;
    function __deleteGroupMembersEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.socialgroups.v1.group_members_event',
            method: 'DELETE',
            methodFqn: 'wix.socialgroups.v1.GroupMemberEventsService.DeleteGroupMembersEvent',
            url: resolveWixSocialgroupsV1GroupMemberEventsServiceUrl({
                protoPath: '/v1/group-members-events/{eventId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteGroupMembersEvent.fromReq = fromReq;
    __deleteGroupMembersEvent.__isAmbassador = true;
    return __deleteGroupMembersEvent;
}
//# sourceMappingURL=http.impl.js.map